import {isPlatformBrowser} from "@angular/common";
import {AfterViewInit, Component, Inject, PLATFORM_ID} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {OAuthService} from "angular-oauth2-oidc";
import {loadMessages, locale} from "devextreme/localization";

import deMessages from "./localization/dx.messages.de.json";
import enMessages from "./localization/dx.messages.en.json";
import nlMessages from "./localization/dx.messages.nl.json";
import plMessages from "./localization/dx.messages.pl.json";

import {ModelService} from "./Services/model.service";
import {InfoPopupService} from "./info/info-popup.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false
})
export class AppComponent implements AfterViewInit {
  public constructor(
    private readonly oauthService: OAuthService,
    private readonly modelService: ModelService,
    private readonly translateService: TranslateService,
    private readonly infoPopupService: InfoPopupService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
    this.initializeDevExtremeLocalization();
    this.initializeTranslation();
    this.initializeOAuth();
  }

  public ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    //<Banner-Info>
    // this.infoPopupService.show({
    //   title: 'Produkt-Update',
    //   message:
    //     'Ihr nextPIM-System erscheint ab dem 08.02.2026 in einem neuen Design! ' +
    //     'Freuen Sie sich auf ein optimiertes Design, verbesserte Katalogansichten und vieles mehr! ' +
    //     '<a href="/newsArticle" target="_blank" rel="noopener noreferrer">Hier mehr erfahren</a>.',
    //   type: 'warning',
    // });
  }

  public get getViewPort(): unknown {
    return this.modelService.loginService.getViewPort();
  }

  private initializeDevExtremeLocalization(): void {
    loadMessages(deMessages);
    loadMessages(enMessages);
    loadMessages(nlMessages);
    loadMessages(plMessages);

    if (isPlatformBrowser(this.platformId)) {
      locale(navigator.language);
    } else {
      locale("de");
    }
  }

  private initializeTranslation(): void {
    const supportedLanguages = ["de", "en", "nl", "pl"] as const;

    this.translateService.addLangs([...supportedLanguages]);
    this.translateService.setFallbackLang("de");

    if (!isPlatformBrowser(this.platformId)) {
      this.translateService.use("de");
      this.translateService.get("de");
      return;
    }

    const browserLanguage = this.translateService.getBrowserLang() ?? "de";
    const selectedLanguage = supportedLanguages.includes(browserLanguage as any)
      ? browserLanguage
      : "de";

    this.translateService.use(selectedLanguage);
    this.translateService.get(selectedLanguage);
  }

  private initializeOAuth(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.oauthService.tokenEndpoint = window.location.origin + "/connect/token";
    this.oauthService.userinfoEndpoint = window.location.origin + "/connect/userinfo";
    this.oauthService.issuer = window.location.origin + "/";
    this.oauthService.clientId = "nextpim";
    this.oauthService.scope = "profile offline_access";
    this.oauthService.responseType = "token";
    this.oauthService.oidc = false;
    this.oauthService.setStorage(localStorage);
  }
}
